import { Loader2 } from 'lucide-react';
import { useCompanyProfile } from '../../../Hooks/useCompanyProfile';
import SettingsHeader from '../components/SettingsHeader';
import CompanyDetailsForm from '../components/CompanyDetailsForm';
import BusinessHoursSection from '../components/BusinessHoursSection';
import TaxSettingsSection from '../components/TaxSettingsSection';
import RegionalSettingsSection from '../components/RegionalSettingsSection';
import { getUserRole } from '../../../utils/permissions';

export default function Settings() {
    const { profile, isLoading, error, updateProfile, isUpdating } = useCompanyProfile();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <Loader2 className="w-12 h-12 animate-spin text-teal-600" />
            </div>
        );
    }

    if (getUserRole() !== 'company') {
        return (
            <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                    <Loader2 className="w-8 h-8 text-red-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
                <p className="text-gray-600 max-w-md">You do not have permission to view or modify company settings. Please contact your administrator.</p>
            </div>
        );
    }

    if (error) {
        return <div className="p-10 text-center text-red-600">Failed to load settings</div>;
    }

    return (
        <section className="min-h-screen text-sm">
            <SettingsHeader isUpdating={isUpdating} />

            <div className="px-4 py-5 space-y-6">
                <CompanyDetailsForm profile={profile} updateProfile={updateProfile} />
                <BusinessHoursSection profile={profile} updateProfile={updateProfile} />
                <TaxSettingsSection profile={profile} updateProfile={updateProfile} />
                <RegionalSettingsSection profile={profile} updateProfile={updateProfile} />
            </div>
        </section>
    );
}